<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.94787 13.6984C9.91914 16.2575 11.9721 18.3105 14.5313 18.2818C17.0904 18.253 19.19 16.1544 19.2188 13.5943C19.2475 11.0341 17.1955 8.98212 14.6354 9.01087C12.0753 9.03962 9.97661 11.1392 9.94787 13.6984ZM15.695 11.8153C15.8982 11.6121 16.2242 11.6081 16.4232 11.8068C16.6218 12.0054 16.6178 12.3315 16.4146 12.535L15.3108 13.6388L16.3901 14.7181C16.5888 14.9168 16.5855 15.2428 16.3823 15.4463C16.1791 15.6497 15.8531 15.6528 15.6541 15.4541L14.5748 14.3748L13.471 15.4786C13.2678 15.6818 12.9417 15.6858 12.7428 15.4871C12.5439 15.2884 12.5481 14.9624 12.7513 14.759L13.8552 13.6551L12.7758 12.5758C12.5772 12.3771 12.5804 12.0511 12.7836 11.848C12.9869 11.6448 13.3129 11.6414 13.5118 11.8401L14.5911 12.9194L15.695 11.8153Z"
      fill="#325EA3"
    />
    <path
      d="M13.1842 8.48111L17.0641 3.72526C17.5861 3.01823 17.131 2 16.2557 2L2.04082 2C1.16593 2 0.682832 3.01823 1.23475 3.69889L7.11119 10.9453V13.9792C7.11119 14.234 7.23253 14.473 7.43744 14.6191L9.56617 16.1426C9.29785 15.4733 9.14825 14.7441 9.14825 13.9792C9.14825 11.3782 10.8543 9.17773 13.1842 8.48111Z"
      fill="#325EA3"
    />
  </svg>
</template>
